export default "__VITE_ASSET__INyE1vRo__"